import Phaser from 'phaser';
import * as ABCya from '@abcya/abcya_phaser';
import FontKeys from '../FontKeys';

/**
 * A Shape includes the shape icon and the shape text beneath the icon.
 */
export default class Shape extends Phaser.GameObjects.Container
{
    /**
     * Create a new Shape.
     * @param {Phaser.Scene} scene the owner scene
     * @param {string} shapeImageKey the shape image key found in the UIAssetKeys
     * @param {string} shapeText the shape text (one of the SHAPE enum values)
     * @param {string} shapeAudioKey the shape audio key found in the SoundAssetKeys
     * @param {number} textYPos the y position of the text below the icon
     */
    constructor(scene, shapeImageKey, shapeText, shapeAudioKey, textYPos = 100)
    {
        super(scene);

        this.scene.add.existing(this);

        this._addShape(shapeImageKey);
        this._addText(shapeText, textYPos);

        this.audio = ABCya.Audio.createSound(scene, 1, false, 0);
        this.audio.on(Phaser.Sound.Events.COMPLETE, () => ABCya.Tweens.addTintTween(this.shapeImage, 0xffffff, 250));

        let bounds = this.getBounds();
        this.add(this.button = this.scene.add.zone(bounds.centerX, bounds.centerY, bounds.width, bounds.height));
        this.button.setInteractive({ useHandCursor: true });
        this.button.on(Phaser.Input.Events.GAMEOBJECT_POINTER_DOWN, () => 
        {
            ABCya.Tweens.addTintTween(this.shapeImage, 0xf9f991, 250);
            this.audio.play(shapeAudioKey);
        });
    }

    /**
     * Sets this shape as interactive.
     */
    setInteractive()
    {
        this.button.setInteractive();
    }

    /**
     * Sets this shape as not interactive.
     */
    disableInteractive()
    {
        this.button.disableInteractive();
    }

    /**
     * Adds the shape icon.
     * @param {string} shapeImageKey the shape image key found in the UIAssetKeys
     */
    _addShape(shapeImageKey)
    {
        this.shapeImage = ABCya.Images.addImage(0, 0, shapeImageKey, this);
    }

    /**
     * Adds the shape text.
     * @param {string} shapeText the shape text
     * @param {number} textYPos the y position of the text
     */
    _addText(shapeText, textYPos = 100)
    {
        this.shapeText = ABCya.Text.addText(0, textYPos, 45, 0x2a5e5e, FontKeys._retrigaregular, shapeText, this).setOrigin(0.5);
    }
}